module.exports = __webpack_public_path__ + "static/music-streaming-web-app-cover-492c84befb70d53a932f7d015aef5ac5.png";